import * as yup from 'yup';
import { compare3DigitsFloats } from 'utils/number';

export const characterizationFormSchema = (pt: any): yup.AnyObjectSchema =>
  yup.object().shape({
    characterizationMaterials: yup
      .array()
      .test('weightSumValidation', pt('validation.weight.sumsDontAddUp'), (value, context) => {
        const totalDeclaredWeight = context.parent.weight;
        const totalWeight =
          value?.reduce((accu: number, material: any) => {
            return parseFloat(material.weight || '0') + accu;
          }, 0) ?? 0;
        return !!value && compare3DigitsFloats(totalWeight, totalDeclaredWeight);
      })
      .of(
        yup.object().shape({
          characterizationSubMaterials: yup
            .array()
            .test('characSubMatWeightSumValidation', pt('validation.weight.sumSubMaterials'), (value, context) => {
              if (undefined === value || 0 === (value.length ?? 0)) return true;
              const characterizationMaterialWeight = context.parent.weight;
              const totalWeight =
                value?.reduce((accu: number, characterizationSubMaterial) => {
                  return parseFloat(characterizationSubMaterial.weight || '0') + accu;
                }, 0) ?? 0;
              return 0 === totalWeight || compare3DigitsFloats(totalWeight, characterizationMaterialWeight)
                ? true
                : context.createError({ message: pt('validation.weight.sumSubMaterials'), path: context.path });
            }),
        }),
      ),
  });
